import React, { FC } from "react"
import hw2 from "../../../assets/images/services-icon/hw2.svg"
import awicon from "../../../assets/images/services-icon/coin.png"
import { Button, Progress } from "reactstrap"
import { LessonActivityOnetime } from "./lesson-activity.types"
import { ActivityUtil } from "./activity-util"


const formatTime = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  const formattedTime = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`
  return formattedTime
}


type HandledTypes = LessonActivityOnetime

interface GeneralActivityHomeworkCardProps {
  activity: HandledTypes,
  onClick?: () => void
}

export const GeneralActivityHomeworkCard: FC<GeneralActivityHomeworkCardProps> = (props: GeneralActivityHomeworkCardProps) => {

  const { activity, onClick } = props

  let total_coins = 0
  let total_time = 0

  let total_question = 0
  let count_answer = 0
  let percentage = 0

  if (activity.LessonActivitiesQuestions?.length > 0) {

    activity.LessonActivitiesQuestions.forEach(
      (activityQuestion, index2) => {
        activityQuestion.question?.forEach((question) => {
          total_question += 1
          total_coins += 2
          if (question.StudentAnsAttempts?.length > 0) {
            question.StudentAnsAttempts.forEach(stuAnswer => {
              total_time += stuAnswer.submitted_on
            })
            count_answer += 1
          }
        })
      })
  }

  if (total_question >= count_answer && total_question != 0) {
    percentage = (count_answer / total_question) * 100
  }

  return (
    <li className="d-flex justify-content-between">
      <div className="d-flex align-items-start w-75 me-5">
        {activity?.status === 1 ? (
          <div className="hw-icon me-3 bg-success text-white font-size-24 me-3">
            <i className="fas fa-check-circle"></i>
          </div>
        ) : (
          <div className="hw-icon me-3">
            <img
              width={24}
              className=""
              src={hw2}
              alt=""
            />
          </div>
        )}
        <div>
          <p className="text-warning mb-2 fw-bold font-size-12 text-uppercase">
            Task
          </p>
          <h4 className=" fw-bold font-size-24">
            {/*{activity.activity_node[0] &&*/}
            {/*activity.activity_node[0]*/}
            {/*  .name != ""*/}
            {/*  ? activity.activity_node[0]*/}
            {/*    .name*/}
            {/*  : null}*/}
            {ActivityUtil.activityName(activity)}
          </h4>
          <div className="ft-util d-flex align-items-center">
            <div className="d-flex align-items-center font-size-18 fw-medium ">
            </div>
            <div className="d-flex align-items-center font-size-18 fw-medium me-3">
              <img
                width={24}
                className="me-2"
                src={awicon}
                alt=""
              />
              {activity.coins_earned ? activity.coins_earned : 0}
              /{activity.activity_node?.[0]?.coins !== undefined && activity.activity_node?.[0]?.coins !== null
              ? activity.activity_node[0]?.coins
              : 2} Coins
            </div>
          </div>
        </div>
      </div>
      {activity?.status === 1 ? (
        <div className="hw-status text-end">
          <div
            className="d-flex align-items-center text-success font-size-18 fw-bold text-uppercase"
            onClick={onClick}
          >
            <span className="mcr-success me-2"></span>
            Completed
          </div>
          <p className="mb-0 text-uppercase font-size-12">
            {formatTime(total_time)} Mins
          </p>
        </div>
      ) : (
        <div className="hw-status text-end w-25">
          {percentage !== 0 ? (
            <>
              <div>
                <Button
                  className="btn btn-danger cs-btn-danger text-uppercase mb-2"
                  onClick={onClick}
                >
                  Resume
                </Button>
              </div>

              <div className="d-flex align-items-center">
                  <span className="me-2">
                    {percentage !== 0
                      ? percentage.toFixed(1)
                      : 0}
                    %
                  </span>
                <div className="flex-grow-1">
                  <Progress
                    color="success"
                    value={
                      percentage !== 0
                        ? percentage
                        : 0
                    }
                  />
                </div>
              </div>
            </>
          ) : (
            <Button
              className="btn btn-danger cs-btn-danger text-uppercase"
              onClick={onClick}
            >
              START
            </Button>
          )}
        </div>
      )}
    </li>
  )

}